<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Nemesis</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#map-central-italia">Map – Central Italia</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#epigraph">Epigraph</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#one">One</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch004#two">Two</a>
</li>
<li id="toc-li-5">
<span href="#/text/ch005#three" title="Link target outside of Sample">Three</span>
</li>
<li id="toc-li-6">
<span href="#/text/ch006#four" title="Link target outside of Sample">Four</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch007#five" title="Link target outside of Sample">Five</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch008#six" title="Link target outside of Sample">Six</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch009#seven" title="Link target outside of Sample">Seven</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch010#eight" title="Link target outside of Sample">Eight</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch011#nine" title="Link target outside of Sample">Nine</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch012#ten" title="Link target outside of Sample">Ten</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch013#eleven" title="Link target outside of Sample">Eleven</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch014#twelve" title="Link target outside of Sample">Twelve</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch015#thirteen" title="Link target outside of Sample">Thirteen</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch016#fourteen" title="Link target outside of Sample">Fourteen</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch017#fifteen" title="Link target outside of Sample">Fifteen</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch018#sixteen" title="Link target outside of Sample">Sixteen</span>
</li>
<li id="toc-li-19">
<span href="#/text/ch019#seventeen" title="Link target outside of Sample">Seventeen</span>
</li>
<li id="toc-li-20">
<span href="#/text/ch020#eighteen" title="Link target outside of Sample">Eighteen</span>
</li>
<li id="toc-li-21">
<span href="#/text/ch021#nineteen" title="Link target outside of Sample">Nineteen</span>
</li>
<li id="toc-li-22">
<span href="#/text/ch022#twenty" title="Link target outside of Sample">Twenty</span>
</li>
<li id="toc-li-23">
<span href="#/text/ch023#twenty-one" title="Link target outside of Sample">Twenty-One</span>
</li>
<li id="toc-li-24">
<span href="#/text/ch024#twenty-two" title="Link target outside of Sample">Twenty-Two</span>
</li>
<li id="toc-li-25">
<span href="#/text/ch025#twenty-three" title="Link target outside of Sample">Twenty-Three</span>
</li>
<li id="toc-li-26">
<span href="#/text/ch026#epilogue" title="Link target outside of Sample">Epilogue</span>
</li>
<li id="toc-li-27">
<span href="#/text/ch027#authors-note" title="Link target outside of Sample">Author’s Note</span>
</li>
<li id="toc-li-28">
<span href="#/text/ch028#characters" title="Link target outside of Sample">Characters</span>
</li>
<li id="toc-li-29">
<span href="#/text/ch029#places-locations" title="Link target outside of Sample">Places / Locations</span>
</li>
<li id="toc-li-30">
<span href="#/text/ch030#conquerors-of-rome" title="Link target outside of Sample">Conquerors of Rome</span>
</li>
<li class="author_bio">
<span href="#/text/author_bio" title="Link target outside of Sample">About the Author</span>
</li>
<li class="also_by">
<span href="#/text/also_by" title="Link target outside of Sample">Also by C. R. May</span>
</li>
<li id="toc-li-31">
<span href="#/text/ch031#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?7e126290